import type { ClientCreate } from "@/types";
import { validateRequired } from "../helpers/validationHelpers";

export const validateClients = (values: ClientCreate): Record<string, string> => {
  const errors: Record<string, string> = {};

  // --- Required Top-Level Fields (per backend validation) ---
  validateRequired(values.client_legal_name, "client_legal_name", errors);

  // --- Business Logic Validations ---

  // If has_children_co is true, client_parent_co should probably be empty
  // (This is a soft validation - just a business logic suggestion)
  if (values.has_children_co === true && values.client_parent_co) {
    errors["client_parent_co"] = "Parent company should typically be empty if client has children companies";
  }

  // If client_parent_co is provided, has_children_co should probably be false
  // (This is a soft validation - just a business logic suggestion)
  if (values.client_parent_co && values.has_children_co === true) {
    errors["has_children_co"] = "Client with a parent company typically should not have children companies";
  }

  // Note: All other fields are optional per backend (omitempty)
  // client_status defaults to ClientStatus.BUILDING in backend if not provided
  // has_active_policy defaults to false in backend if not provided

  return errors;
};
